import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { uuidV4, CANCEL_KEYS } from '@adsk/docs-http-client';
import Oss from '@adsk/docs-oss-sdk';
import Base from './base';
import { EntityItem } from '../models';
import { UploadUtil, CommonUtil } from '../utils';
import { UPLOAD_ERRORS } from '../utils/consts';
var ossService;

/**
 * `Service` The search service
 */
var Upload = /*#__PURE__*/function (_Base) {
  /**
   * Create the upload service instance.
   *
   * @param sdk - the SDK instance
   */
  function Upload(sdk) {
    var _this;
    _classCallCheck(this, Upload);
    _this = _callSuper(this, Upload, [sdk]);
    _this.sessionId = uuidV4();
    return _this;
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(Upload, _Base);
  return _createClass(Upload, [{
    key: "getOssService",
    value:
    /**
     * Initialize OSS service
     */
    function getOssService() {
      if (!ossService) {
        ossService = new Oss({
          env: this.Config.env,
          getAccessToken: this.Config.getToken,
          getRequestId: CommonUtil.getRequestId,
          logger: this.Config.logger,
          circuitBreaker: this.Config.circuitBreaker
        });
      }
      return ossService;
    }

    /**
     * Upload file to docs folder
     *
     * @param projectId -  the project uuid
     * @param folderUrn -  Target folder urn
     * @param file - The browser file object
     * @param params - The upload related object, with the shape of
     *                         \{
     *                            skipCommand: true / false,      // If create upload command, default false
     *                            linked: true/false,             // If linked file upload, default false
     *                            sheets: true/false,             // If upload to sheets, default false
     *                            fileChunkSize: number,          // Upload file trunk, default to 5MB at oss sdk [Valid at new upload only]
     *                            // Control function
     *                           isAborted: () =\> true/false      // control if the file upload is aborted
     *                           isPaused: () =\> true/false       // control if the file upload is paused
     *                           onProgress: (percentage) =\> none // indicate the upload progress from 0-100
     *                           onUploaded: () =\> none           // uploading file to OSS success callback
     *                         \}
     * @returns The command process upload command response
     */
  }, {
    key: "uploadFile",
    value: (function () {
      var _uploadFile = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, folderUrn, file, params) {
        var _options$onStart, _options$onUploaded;
        var options, validation, objectId, _options$onStorage, response, headers, res, _res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              options = params || {};
              _context.next = 3;
              return UploadUtil.validateFile(file, options);
            case 3:
              validation = _context.sent;
              if (!validation.code) {
                _context.next = 6;
                break;
              }
              throw validation;
            case 6:
              (_options$onStart = options.onStart) === null || _options$onStart === void 0 ? void 0 : _options$onStart.call(options);

              /**
               * Get file storage urn.
               * If options.storageUrn is defined just skip it, this happens in retry.
               */
              objectId = options.storageUrn;
              if (objectId) {
                _context.next = 20;
                break;
              }
              _context.prev = 9;
              _context.next = 12;
              return this.SDK.Projects.getStorage(projectId, {
                fileName: file.name
              });
            case 12:
              response = _context.sent;
              objectId = response.objectId;
              (_options$onStorage = options.onStorage) === null || _options$onStorage === void 0 ? void 0 : _options$onStorage.call(options, objectId);
              _context.next = 20;
              break;
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](9);
              throw {
                error: _context.t0,
                code: UPLOAD_ERRORS.STORAGE_URN_FAILURE
              };
            case 20:
              _context.prev = 20;
              // signed url restricts headers.
              headers = _extends({}, options.headers);
              if (headers['x-acs-batch-id']) {
                delete headers['x-acs-batch-id'];
              }
              if (headers['x-acs-auto-review']) {
                delete headers['x-acs-auto-review'];
              }
              _context.next = 26;
              return this.getOssService().upload(file, _extends({}, options, {
                headers: headers,
                objectId: objectId,
                abortOnFailure: true
              }));
            case 26:
              _context.next = 31;
              break;
            case 28:
              _context.prev = 28;
              _context.t1 = _context["catch"](20);
              throw {
                error: _context.t1,
                code: UPLOAD_ERRORS.UPLOAD_FAILURE,
                storageUrn: objectId
              };
            case 31:
              (_options$onUploaded = options.onUploaded) === null || _options$onUploaded === void 0 ? void 0 : _options$onUploaded.call(options);
              if (!(options.skipCommand === true)) {
                _context.next = 36;
                break;
              }
              return _context.abrupt("return", {
                file: file,
                storageUrn: objectId
              });
            case 36:
              _context.prev = 36;
              if (!options.useUploadV3Api) {
                _context.next = 44;
                break;
              }
              _context.next = 40;
              return this.createUploadV3(projectId, folderUrn, _extends({
                storageUrn: objectId,
                name: file.name,
                size: file.size,
                customAttributes: file.customAttributes
              }, !!file.fileFormat && {
                fileFormat: file.fileFormat
              }), options);
            case 40:
              res = _context.sent;
              return _context.abrupt("return", res);
            case 44:
              _context.next = 46;
              return this.HttpService.cpV1.post("/projects/".concat(projectId, "/commands"), UploadUtil.getUploadPayload(folderUrn, [{
                name: file.name,
                size: file.size,
                storageUrn: objectId,
                versionExtensionProperties: file.versionExtensionProperties
              }]));
            case 46:
              _res = _context.sent;
              return _context.abrupt("return", _res.data);
            case 48:
              _context.next = 53;
              break;
            case 50:
              _context.prev = 50;
              _context.t2 = _context["catch"](36);
              throw {
                error: _context.t2,
                code: options.useUploadV3Api ? UPLOAD_ERRORS.UPLOAD_API_FAILURE : UPLOAD_ERRORS.UPLOAD_COMMAND_FAILURE,
                storageUrn: objectId
              };
            case 53:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[9, 17], [20, 28], [36, 50]]);
      }));
      function uploadFile(_x, _x2, _x3, _x4) {
        return _uploadFile.apply(this, arguments);
      }
      return uploadFile;
    }()
    /**
     * Call command processor to create upload command with a give storage urn
     * which has been uploaded to oss.
     *
     * @param projectId -  the project uuid
     * @param folderUrn - target folder urn
     * @param files - the target files to upload with the shape of [\{ name, size, storageUrn \}]
     * @param config - configurable object for overwrite request parameters.
     */
    )
  }, {
    key: "createUpload",
    value: (function () {
      var _createUpload = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, folderUrn, files, config) {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.HttpService.cpV1.post("/projects/".concat(projectId, "/commands"), UploadUtil.getUploadPayload(folderUrn, files), config);
            case 2:
              res = _context2.sent;
              return _context2.abrupt("return", res.data);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function createUpload(_x5, _x6, _x7, _x8) {
        return _createUpload.apply(this, arguments);
      }
      return createUpload;
    }()
    /**
     * Upload single file with restful API instead of upload command
     *
     * https://platform.stoplight.autodesk.com/docs/docs-cp/b9ad65f2da98b-shared-upload-document-to-folder
     *
     * @param projectId - the project uuid
     * @param folderUrn - the parent folder urn
     * @param file - to upload file with shape of \{ name, storageUrn, customAttributes, fileFormat \}
     * @param config - configurable object for overwrite request parameters
     *
     * @returns Promise<Object>
     */
    )
  }, {
    key: "createUploadV3",
    value: (function () {
      var _createUploadV = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(projectId, folderUrn, file, config) {
        var _res$data;
        var path, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              path = "/projects/".concat(projectId, "/folders/").concat(folderUrn, "/documents");
              _context3.next = 3;
              return this.HttpService.dmV3.post(path, {
                file: file
              }, config);
            case 3:
              res = _context3.sent;
              return _context3.abrupt("return", EntityItem.parseV3(((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.document) || {}));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function createUploadV3(_x9, _x10, _x11, _x12) {
        return _createUploadV.apply(this, arguments);
      }
      return createUploadV3;
    }()
    /**
     * Remove an uploaded file from oss by the storage urn.
     *
     * @param storageUrn - The file storage urn
     * @param config - configurable object for overwrite request parameters
     *
     * @returns Promise<undefined>
     */
    )
  }, {
    key: "removeOssFile",
    value: (function () {
      var _removeOssFile = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(storageUrn, config) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.getOssService()["delete"](storageUrn, config);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function removeOssFile(_x13, _x14) {
        return _removeOssFile.apply(this, arguments);
      }
      return removeOssFile;
    }()
    /**
     * Cancel upload by version files
     *
     * @param projectId -  the project uuid
     * @param versionUrns - the target version urn array, ['versionUrn1', 'versionUrn2']
     * @param config - configurable object to overwrite request parameters.
     *
     * @returns Promise<object>
     */
    )
  }, {
    key: "cancelUpload",
    value: (function () {
      var _cancelUpload = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(projectId, versionUrns, config) {
        var res;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.HttpService.cpV1.post("/projects/".concat(projectId, "/commands"), UploadUtil.getCancelPayload(versionUrns), config);
            case 2:
              res = _context5.sent;
              return _context5.abrupt("return", res.data);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function cancelUpload(_x15, _x16, _x17) {
        return _cancelUpload.apply(this, arguments);
      }
      return cancelUpload;
    }()
    /**
     * Process on-demand upload files.
     *
     * @param projectId - the project id.
     * @param payload - with shape \{ files: [\{ versionName, versionUrn, parentFolderUrn \}] \}
     * @param config - configurable object to overwrite request parameters.
     *
     * @returns Promise<Object>
     */
    )
  }, {
    key: "processFiles",
    value: (function () {
      var _processFiles = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(projectId, payload, config) {
        var _this2 = this;
        var res;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              config = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this2.processFileCancelToken;
                },
                setter: function setter(token) {
                  return _this2.processFileCancelToken = token;
                },
                clearer: function clearer() {
                  return _this2.processFileCancelToken = undefined;
                }
              }), config);
              _context6.next = 3;
              return this.HttpService.cpV1.post("/projects/".concat(projectId, "/commands"), UploadUtil.getProcessPayload(payload), config);
            case 3:
              res = _context6.sent;
              return _context6.abrupt("return", res.data);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function processFiles(_x18, _x19, _x20) {
        return _processFiles.apply(this, arguments);
      }
      return processFiles;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Upload';
    }
  }]);
}(Base);
export default Upload;